import hydrateProductCardDeferredMedia from './hydrate-product-card-deferred-media';

const desktopMediaQuery = '(min-width: 1024px)';

/**
 * Desktop product-card: hover crossfade between pack / on-model, carousel / control rules.
 * @param {HTMLElement} productItem .js-productItem
 */
export default function initProductCardMediaHover(productItem) {
  const stack = productItem.querySelector('.js-productCardMediaStack');
  const swiperEl = productItem.querySelector('.js-mediaSlider');
  if (!stack || !swiperEl || !swiperEl.swiper) return;

  const prevBtn = productItem.querySelector('.js-mediaSliderPrevBtn');
  const nextBtn = productItem.querySelector('.js-mediaSliderNextBtn');
  const pagination = productItem.querySelector('.js-mediaSliderPagination');
  const mq = window.matchMedia(desktopMediaQuery);

  const sw = swiperEl.swiper;

  const setCarouselLocked = (on) => {
    productItem.classList.toggle('product-item--carouselSwapActive', on);
  };

  const setNextArrowHover = (on) => {
    productItem.classList.toggle('product-item--nextArrowHover', on);
  };

  const lockCarousel = () => {
    if (!mq.matches) return;
    setCarouselLocked(true);
  };

  const syncNextArrowHover = () => {
    if (!mq.matches || sw.activeIndex !== 0) {
      setNextArrowHover(false);
    }
  };

  /**
   * On first slide, hovering the "next" control resets the stack to the default first-slide look
   * (as if you are on slide 1 without image-hover), while Swiper index stays 0.
   */
  const onNextControlEnter = () => {
    if (!mq.matches || sw.activeIndex !== 0) return;
    setNextArrowHover(true);
  };

  const onNextControlLeave = () => {
    setNextArrowHover(false);
  };

  const hydrateBeforeNavigate = () => {
    hydrateProductCardDeferredMedia(productItem, { full: true });
    swiperEl.swiper?.update();
  };

  prevBtn?.addEventListener('click', () => {
    hydrateBeforeNavigate();
    lockCarousel();
  });
  nextBtn?.addEventListener('click', () => {
    hydrateBeforeNavigate();
    lockCarousel();
  });
  nextBtn?.addEventListener('mouseenter', onNextControlEnter);
  nextBtn?.addEventListener('mouseleave', onNextControlLeave);
  nextBtn?.addEventListener('focusin', onNextControlEnter);
  nextBtn?.addEventListener('focusout', onNextControlLeave);

  sw.on('slideChange', syncNextArrowHover);

  pagination?.addEventListener('click', (e) => {
    if (e.target.closest('.product__media-slider__page-bullet')) lockCarousel();
  });

  productItem.addEventListener('mouseleave', () => {
    setCarouselLocked(false);
    setNextArrowHover(false);
  });
}
